exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-icon[data-v-7c6762b7] {\n  color: white;\n}\n.disabled[data-v-7c6762b7] {\n  pointer-events: none;\n}\n", ""]);
